import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import utils from "../../utils/utils";
import {FormattedMessage} from "react-intl";

const AdminCtaRow = ({cta}) => {
  const dateCreated = utils.getDateFromString(cta.dateCreated).format('DD-MM-YYYY');
  const image = cta.image? <img src={cta.image.thumbnailImage}/>: '';

  return (
    <tr>
      <th scope="row">
        {cta.id}
      </th>
      <td className="admin-table__image">
        {image}
      </td>
      <td>
        <FormattedMessage id={`cta.form.field.type.name.${cta.type}`}/>
      </td>
      <td>
        {cta.title}
      </td>
      <td>
        {cta.marketplaceCategory}
      </td>
      <td>
        {cta.url}
      </td>
      <td>
        {dateCreated}
      </td>
      <td>
        <Link to={`/admin/ctas/edit/${cta.id}`} className="link">
          Edit
        </Link>
      </td>
    </tr>
  );
}

AdminCtaRow.propTypes = {
  groupProjectResponse: PropTypes.object.isRequired,
};

AdminCtaRow.defaultProps = {
  groupProjectResponse: {},
};

export default AdminCtaRow;